import { render } from "./PartidasDoTimeModal.vue?vue&type=template&id=2ab14d69&scoped=true"
import script from "./PartidasDoTimeModal.vue?vue&type=script&lang=js"
export * from "./PartidasDoTimeModal.vue?vue&type=script&lang=js"

import "./PartidasDoTimeModal.vue?vue&type=style&index=0&id=2ab14d69&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ab14d69"]])

export default __exports__